(function () {
  'use strict';

  if (customElements.get('never-tap-fit-finder')) return;

  const core = window.NeverTapFitCore;
  if (!core) return;

  const escapeHtml = (value) =>
    String(value == null ? '' : value).replace(/[&<>'"]/g, (character) => {
      const entities = { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' };
      return entities[character];
    });

  class NeverTapFitFinder extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const configNode = this.querySelector('[data-nt-fit-config]');
      if (!configNode) return;

      try {
        this.config = JSON.parse(configNode.textContent);
      } catch (error) {
        console.warn('[Never Tap Fit Finder] Ungültige Konfiguration.', error);
        return;
      }

this.profile = core.resolveProfile(this.config.profiles, this.config.product);
if (!this.profile) return;

/*
 * MMA Shorts erkennen.
 *
 * Bei MMA Shorts gibt es keine Auswahl zwischen
 * eng anliegend und locker.
 */
this.isMmaShorts =
  core.normalize(this.profile.key) === 'MMA_SHORTS';

/*
 * "tight" bleibt intern der Standardwert.
 *
 * Beim Rashguard bedeutet das "Eng anliegend".
 * Bei MMA Shorts wird derselbe Berechnungsweg einfach
 * als normaler Fit verwendet.
 */
this.answers = {
  height: '',
  weight: '',
  body: 'athletic',
  fit: 'tight'
};

this.steps = ['height', 'weight'];

if (this.config.ui.showBodyQuestion) {
  this.steps.push('body');
}

/*
 * Fit-Frage nur bei Produkten anzeigen,
 * die KEINE MMA Shorts sind.
 */
if (
  this.config.ui.showFitQuestion &&
  !this.isMmaShorts
) {
  this.steps.push('fit');
}

this.currentStep = 0;
const guidePanel = this.querySelector('[data-nt-guide-panel]');
const guideButton = this.querySelector('[data-action="toggle-guide"]');

if (guidePanel) guidePanel.hidden = true;

if (guideButton) {
  guideButton.setAttribute('aria-expanded', 'false');
  guideButton.textContent = 'Größentabelle anzeigen';
}
this.lastFocused = null;

      this.renderShell();
      this.injectTrigger();
      this.bindEvents();
    }

    renderShell() {
      const ui = this.config.ui;
      this.insertAdjacentHTML(
        'beforeend',
        `<div class="nt-fit__modal" data-nt-modal hidden>
          <button class="nt-fit__backdrop" type="button" aria-label="${escapeHtml(ui.closeLabel)}" data-action="close"></button>
          <section class="nt-fit__dialog" role="dialog" aria-modal="true" aria-labelledby="nt-fit-title-${escapeHtml(this.config.sectionId)}" tabindex="-1">
            <header class="nt-fit__header">
              <div>
                <p class="nt-fit__eyebrow">${escapeHtml(ui.eyebrow)}</p>
                <h2 class="nt-fit__title" id="nt-fit-title-${escapeHtml(this.config.sectionId)}">${escapeHtml(ui.heading)}</h2>
              </div>
              <button class="nt-fit__close" type="button" aria-label="${escapeHtml(ui.closeLabel)}" data-action="close">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>
              </button>
            </header>
            ${this.profile.guideUrl ? `
  <div class="nt-fit__guide-box">
    <button
      type="button"
      class="nt-fit__button nt-fit__button--secondary nt-fit__guide-toggle"
      data-action="toggle-guide"
      aria-expanded="false"
      aria-controls="nt-fit-guide-${escapeHtml(this.config.sectionId)}"
    >
      Größentabelle anzeigen
    </button>

    <div
      class="nt-fit__guide-panel"
      id="nt-fit-guide-${escapeHtml(this.config.sectionId)}"
      data-nt-guide-panel
      hidden
    >
      <img
        class="nt-fit__guide"
        src="${escapeHtml(this.profile.guideUrl)}"
        alt="${escapeHtml(this.profile.guideAlt || 'Größentabelle')}"
        loading="lazy"
      >
    </div>
  </div>
` : ''}
            <div class="nt-fit__progress" data-nt-progress aria-label="Fortschritt"></div>
            <div class="nt-fit__content" data-nt-content aria-live="polite"></div>
          </section>
        </div>`
      );
      this.modal = this.querySelector('[data-nt-modal]');
      this.dialog = this.querySelector('.nt-fit__dialog');
      this.content = this.querySelector('[data-nt-content]');
      this.progress = this.querySelector('[data-nt-progress]');
    }

    injectTrigger() {
      const productInfo = document.querySelector(`product-info[data-product-id="${this.config.product.id}"]`);
      if (!productInfo) return;

      const acceptedNames = String(this.config.ui.sizeOptionNames || '')
        .split(',')
        .map(core.normalize)
        .filter(Boolean);
      const fieldset = Array.from(productInfo.querySelectorAll('fieldset')).find((element) => {
        const legend = element.querySelector('legend');
        return legend && acceptedNames.includes(core.normalize(legend.textContent));
      });
      const picker = productInfo.querySelector('variant-selects, variant-radios, variant-picker');
      const anchor = fieldset || picker;
      if (!anchor) return;

      this.triggerWrap = document.createElement('div');
      this.triggerWrap.className = 'nt-fit__trigger-wrap';
      this.triggerWrap.innerHTML = `<span>${escapeHtml(this.config.ui.triggerPrompt)}</span><button type="button" class="nt-fit__trigger" data-nt-trigger>${escapeHtml(this.config.ui.buttonText)}<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M14 6l6 6-6 6"/></svg></button>`;
      anchor.insertAdjacentElement('afterend', this.triggerWrap);
      this.trigger = this.triggerWrap.querySelector('[data-nt-trigger]');
    }

    bindEvents() {
      if (!this.trigger) return;
      this.trigger.addEventListener('click', () => this.open());
      this.modal.addEventListener('click', (event) => this.handleClick(event));
      this.modal.addEventListener('input', (event) => this.handleInput(event));
      this.modal.addEventListener('change', (event) => this.handleInput(event));
      this.boundKeydown = (event) => this.handleKeydown(event);
    }

    open() {
      this.lastFocused = document.activeElement;
      this.currentStep = 0;
      this.modal.hidden = false;
      document.body.classList.add('nt-fit-open');
      document.addEventListener('keydown', this.boundKeydown);
      this.pushEvent('fit_finder_opened', { profile: this.profile.key });

const validRuleCount = (this.config.rules || []).filter(
  (rule) =>
    rule.enabled === true &&
    core.isCompleteRule(rule) &&
    core.normalize(rule.profileKey) ===
      core.normalize(this.profile.key)
).length;

if (validRuleCount >= 2) {
  this.renderStep();
} else {
  this.renderFallback();
}

      window.requestAnimationFrame(() => {
        const firstControl = this.dialog.querySelector('button:not([disabled]), input:not([disabled]), [href]');
        (firstControl || this.dialog).focus();
      });
    }

    close() {
      this.modal.hidden = true;
      document.body.classList.remove('nt-fit-open');
      document.removeEventListener('keydown', this.boundKeydown);
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus();
    }

    handleClick(event) {
      const action = event.target.closest('[data-action]');
      if (!action) return;

      switch (action.dataset.action) {
        case 'close':
          this.close();
          break;
        case 'next':
          this.next();
          break;
        case 'back':
          this.currentStep = Math.max(0, this.currentStep - 1);
          this.renderStep();
          break;
        case 'select-size':
          this.selectSize(action.dataset.size);
          break;
        case 'open-guide':
          this.openExistingGuide();
          break;
          case 'toggle-guide':
  this.toggleGuide(action);
  break;
      }
    }

    handleInput(event) {
      const field = event.target.dataset.field;
      if (!field) return;
      this.answers[field] = event.target.value;
      event.target.removeAttribute('aria-invalid');
      const error = this.content.querySelector('[data-nt-error]');
      if (error) error.textContent = '';
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      if (event.key !== 'Tab') return;
      const focusable = Array.from(
        this.dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')
      ).filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    renderProgress() {
      const total = this.steps.length;
      this.progress.innerHTML = `<span>Schritt ${this.currentStep + 1} von ${total}</span><div>${this.steps
        .map((_, index) => `<i class="${index <= this.currentStep ? 'is-active' : ''}"></i>`)
        .join('')}</div>`;
      this.progress.hidden = false;
    }

    renderStep() {
      this.renderProgress();
      const step = this.steps[this.currentStep];
      const isFirst = this.currentStep === 0;
      const isLast = this.currentStep === this.steps.length - 1;
      let body = '';

      if (step === 'height') {
        body = this.numberStep('Wie groß bist du?', 'Körpergröße in Zentimetern', 'height', 'cm', this.config.ui.minHeight, this.config.ui.maxHeight);
      } else if (step === 'weight') {
        body = this.numberStep('Wie viel wiegst du?', 'Gewicht in Kilogramm', 'weight', 'kg', this.config.ui.minWeight, this.config.ui.maxWeight);
      } else if (step === 'body') {
        body = this.choiceStep('Wie würdest du deinen Körperbau einschätzen?', 'body', [
          ['slim', 'Schmal', 'Eher schlanke Statur'],
          ['athletic', 'Athletisch', 'Ausgewogene, sportliche Statur'],
          ['strong', 'Kräftig', 'Breiter oder muskulöser gebaut'],
        ]);
} else {
  body = this.choiceStep('Wie möchtest du das Produkt tragen?', 'fit', [
    ['tight', 'Eng anliegend', 'Unser empfohlener Rashguard-Fit – körpernah und komprimierend'],
    ['loose', 'Etwas lockerer', 'Weniger Kompression und etwas mehr Bewegungsfreiheit'],
  ]);
}

      this.content.innerHTML = `<div class="nt-fit__step">${body}<p class="nt-fit__error" data-nt-error role="alert"></p><div class="nt-fit__actions">${
        isFirst ? '' : '<button type="button" class="nt-fit__button nt-fit__button--ghost" data-action="back">Zurück</button>'
      }<button type="button" class="nt-fit__button nt-fit__button--primary" data-action="next">${isLast ? 'Größe berechnen' : 'Weiter'}</button></div></div>`;
      const firstField = this.content.querySelector('input');
      if (firstField) window.requestAnimationFrame(() => firstField.focus());
    }

    numberStep(title, label, field, unit, min, max) {
      return `<h3>${escapeHtml(title)}</h3><p class="nt-fit__hint">Bitte gib einen Wert zwischen ${min} und ${max} ${unit} ein.</p><label class="nt-fit__number"><span>${escapeHtml(label)}</span><span class="nt-fit__input-wrap"><input data-field="${field}" type="number" inputmode="decimal" min="${min}" max="${max}" step="1" value="${escapeHtml(this.answers[field])}" required><b>${unit}</b></span></label>`;
    }

    choiceStep(title, field, options) {
      return `<h3>${escapeHtml(title)}</h3><div class="nt-fit__choices">${options
        .map(
          ([value, label, description]) =>
            `<label class="nt-fit__choice"><input data-field="${field}" type="radio" name="nt-${field}-${escapeHtml(this.config.sectionId)}" value="${value}" ${
              this.answers[field] === value ? 'checked' : ''
            }><span><strong>${escapeHtml(label)}</strong><small>${escapeHtml(description)}</small></span></label>`
        )
        .join('')}</div>`;
    }

    next() {
      const step = this.steps[this.currentStep];
      const error = this.content.querySelector('[data-nt-error]');

      if (step === 'height' || step === 'weight') {
        const input = this.content.querySelector(`[data-field="${step}"]`);
        const value = Number(input.value);
        const min = Number(step === 'height' ? this.config.ui.minHeight : this.config.ui.minWeight);
        const max = Number(step === 'height' ? this.config.ui.maxHeight : this.config.ui.maxWeight);
        if (!Number.isFinite(value) || value < min || value > max) {
          input.setAttribute('aria-invalid', 'true');
          error.textContent = `Bitte gib einen Wert zwischen ${min} und ${max} ${step === 'height' ? 'cm' : 'kg'} ein.`;
          input.focus();
          return;
        }
        this.answers[step] = value;
      }

      if (this.currentStep < this.steps.length - 1) {
        this.currentStep += 1;
        this.renderStep();
      } else {
        this.renderResult();
      }
    }

renderResult() {
  this.progress.hidden = true;

  const result = core.recommend(
    this.config,
    this.answers,
    this.profile
  );

  /*
   * Nur echte Konfigurationsprobleme führen
   * noch zum Fallback.
   */
  if (result.status !== 'ok') {
    this.renderFallback(
      this.config.ui.fallbackText
    );
    return;
  }

  /*
   * -------------------------------------------------------
   * ANALYTICS
   * -------------------------------------------------------
   */
  this.pushEvent(
    'fit_finder_completed',
    {
      profile: this.profile.key,
    }
  );

  this.pushEvent(
    'fit_finder_size_recommended',
    {
      profile: this.profile.key,

      recommended_size:
        result.idealSize,

      nearby_size:
        result.nearbySize,

      recommendation_strength:
        result.confidence,

      recommendation_reason:
        result.reason,

      match_mode:
        result.matchMode,

      available:
        result.available,
    }
  );

  /*
   * -------------------------------------------------------
   * ZUSAMMENFASSUNG DER ANGABEN
   * -------------------------------------------------------
   */
  const summary = `
    <dl class="nt-fit__summary">

      <div>
        <dt>Körpergröße</dt>
        <dd>${escapeHtml(this.answers.height)} cm</dd>
      </div>

      <div>
        <dt>Gewicht</dt>
        <dd>${escapeHtml(this.answers.weight)} kg</dd>
      </div>

      ${
        this.config.ui.showBodyQuestion
          ? `
            <div>
              <dt>Körperbau</dt>
              <dd>${escapeHtml(this.bodyLabel())}</dd>
            </div>
          `
          : ''
      }

${
  this.config.ui.showFitQuestion &&
  !this.isMmaShorts
    ? `
      <div>
        <dt>Passform</dt>
        <dd>${escapeHtml(this.fitLabel())}</dd>
      </div>
    `
    : ''
}

    </dl>
  `;

  /*
   * -------------------------------------------------------
   * CONFIDENCE TEXT
   * -------------------------------------------------------
   */
  let confidence = '';

  /*
   * Zwei plausible Größen.
   */
if (
  !this.isMmaShorts &&
  result.confidence === 'between' &&
  result.nearbySize
) {
    const nearbyDescription =
      result.nearbyFit === 'tighter'
        ? 'enger und stärker komprimierend'
        : 'etwas lockerer';

    const splitText =
      result.measurementSplit
        ? 'Körpergröße und Gewicht deuten auf zwei benachbarte Größen.'
        : 'Deine Angaben liegen nah zwischen zwei Größen.';

    confidence = `
      <div class="nt-fit__between">

        <strong>
          Du liegst zwischen zwei Größen.
        </strong>

        <p>
          ${escapeHtml(splitText)}
          ${escapeHtml(result.idealSize)}
          ist für deine gewählte Passform unsere Hauptempfehlung.
          ${escapeHtml(result.nearbySize)}
          ist ebenfalls möglich und sitzt
          ${escapeHtml(nearbyDescription)}.
        </p>

      </div>
    `;
  }

  /*
   * Körperdaten liegen ungewöhnlich weit auseinander
   * oder außerhalb der hinterlegten Regeln.
   *
   * Trotzdem liefern wir eine Empfehlung.
   */
  else if (result.confidence === 'low') {
    let lowText =
      'Auf Basis deiner Angaben ist dies die wahrscheinlich passendste Größe in unserem Sortiment.';

    if (
      result.reason ===
      'measurement_conflict'
    ) {
      lowText =
        'Körpergröße und Gewicht deuten auf unterschiedliche Größenbereiche. Wir haben deshalb die insgesamt passendste Größe aus beiden Angaben berechnet.';
    }

    if (
      result.reason ===
      'outside_rules'
    ) {
      lowText =
        'Deine Angaben liegen teilweise außerhalb unserer üblichen Größenbereiche. Wir zeigen dir trotzdem die Größe, die deinen Angaben am nächsten kommt.';
    }

    confidence = `
      <div class="nt-fit__notice">

        <strong>
          Unsere beste Empfehlung
        </strong>

        <p>
          ${escapeHtml(lowText)}
        </p>

      </div>
    `;
  }

  /*
   * Klare Empfehlung.
   */
else {
  const confidenceText = this.isMmaShorts
    ? 'Klare Größenempfehlung auf Basis deiner Angaben.'
    : 'Klare Empfehlung auf Basis deiner Angaben und gewünschten Passform.';

  confidence = `
    <p class="nt-fit__confidence">
      ${escapeHtml(confidenceText)}
    </p>
  `;
}

  /*
   * -------------------------------------------------------
   * GRÖSSENBUTTONS
   * -------------------------------------------------------
   */
  let availability = '';

  /*
   * Hauptgröße ist verfügbar.
   */
  if (result.available) {
    availability += `
      <button
        type="button"
        class="nt-fit__button nt-fit__button--primary nt-fit__select"
        data-action="select-size"
        data-size="${escapeHtml(result.idealSize)}"
      >
        ${escapeHtml(result.idealSize)} auswählen
      </button>
    `;

    /*
     * Wenn eine zweite plausible Größe existiert,
     * kann der Kunde auch diese direkt auswählen.
     */
if (
  !this.isMmaShorts &&
  result.confidence === 'between' &&
  result.nearbySize &&
  result.nearbyAvailable
) {
      const secondaryButtonText =
        result.nearbyFit === 'tighter'
          ? `${result.nearbySize} – enger wählen`
          : `${result.nearbySize} – lockerer wählen`;

      availability += `
        <button
          type="button"
          class="nt-fit__button nt-fit__button--secondary"
          data-action="select-size"
          data-size="${escapeHtml(result.nearbySize)}"
        >
          ${escapeHtml(secondaryButtonText)}
        </button>
      `;
    }
  }

  /*
   * Hauptgröße ist ausverkauft.
   */
  else {
    availability += `
      <div class="nt-fit__notice">

        <strong>
          Größe ${escapeHtml(result.idealSize)}
          ist aktuell nicht verfügbar.
        </strong>

<p>
  ${
    this.isMmaShorts
      ? `Deine empfohlene Größe bleibt ${escapeHtml(result.idealSize)}.`
      : `Deine eigentliche Größenempfehlung bleibt ${escapeHtml(result.idealSize)}. Falls eine sinnvolle Alternative verfügbar ist, kannst du sie unten auswählen.`
  }
</p>

      </div>
    `;

if (!this.isMmaShorts) {
  availability += result.alternatives
    .map((alternative) => {
      const label =
        alternative.fit === 'tighter'
          ? `${alternative.size} – engere Alternative`
          : `${alternative.size} – lockerere Alternative`;

      return `
        <button
          type="button"
          class="nt-fit__button nt-fit__button--secondary"
          data-action="select-size"
          data-size="${escapeHtml(alternative.size)}"
        >
          ${escapeHtml(label)}
        </button>
      `;
    })
    .join('');
}
  }

  /*
   * -------------------------------------------------------
   * ENDGÜLTIGES ERGEBNIS
   * -------------------------------------------------------
   */
  this.content.innerHTML = `
    <div class="nt-fit__result">

      <p class="nt-fit__result-kicker">
        Deine empfohlene Größe
      </p>

      <strong class="nt-fit__size">
        ${escapeHtml(result.idealSize)}
      </strong>

      <h3>
        ${escapeHtml(result.idealSize)}
        passt wahrscheinlich am besten zu dir.
      </h3>

      ${confidence}

      ${summary}

      <div class="nt-fit__result-actions">

        ${availability}

        <button
          type="button"
          class="nt-fit__button nt-fit__button--ghost"
          data-action="back"
        >
          Angaben ändern
        </button>

      </div>

    </div>
  `;

  this.content
    .querySelector('button')
    ?.focus();
}
    renderFallback(message) {
      this.progress.hidden = true;
      const guide = this.profile.guideUrl
        ? `<img class="nt-fit__guide" src="${escapeHtml(this.profile.guideUrl)}" alt="${escapeHtml(this.profile.guideAlt || 'Größentabelle')}">`
        : '';
      this.content.innerHTML = `<div class="nt-fit__fallback"><h3>Größenhilfe für ${escapeHtml(this.profile.name)}</h3><p>${escapeHtml(message || this.config.ui.fallbackText)}</p>${guide}<div class="nt-fit__actions"><button type="button" class="nt-fit__button nt-fit__button--secondary" data-action="open-guide">Vorhandene Größentabelle öffnen</button><button type="button" class="nt-fit__button nt-fit__button--ghost" data-action="close">Schließen</button></div></div>`;
    }

    toggleGuide(button) {
  const panel = this.querySelector('[data-nt-guide-panel]');
  if (!panel) return;

  const shouldOpen = panel.hidden;

  panel.hidden = !shouldOpen;
  button.setAttribute('aria-expanded', String(shouldOpen));
  button.textContent = shouldOpen
    ? 'Größentabelle ausblenden'
    : 'Größentabelle anzeigen';

  if (shouldOpen) {
    panel.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth',
      block: 'nearest',
    });
  }
}

    openExistingGuide() {
      const labels = String(this.config.ui.sizeGuideLabels || '')
        .split(',')
        .map(core.normalize)
        .filter(Boolean);
      const button = Array.from(document.querySelectorAll('button, summary')).find((element) => {
        if (element.closest('never-tap-fit-finder')) return false;
        const text = core.normalize(element.textContent);
        return labels.some((label) => text.includes(label));
      });
      this.close();
      if (button) {
        button.click();
        button.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      }
    }

    selectSize(size) {
      const productInfo = document.querySelector(`product-info[data-product-id="${this.config.product.id}"]`);
      if (!productInfo) return;
      const acceptedNames = String(this.config.ui.sizeOptionNames || '')
        .split(',')
        .map(core.normalize)
        .filter(Boolean);
      const fieldset = Array.from(productInfo.querySelectorAll('fieldset')).find((element) => {
        const legend = element.querySelector('legend');
        return legend && acceptedNames.includes(core.normalize(legend.textContent));
      });
      const radio = fieldset
        ? Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((input) => core.normalize(input.value) === core.normalize(size))
        : null;

      if (radio && !radio.disabled && !radio.classList.contains('disabled')) {
        radio.click();
        this.pushEvent('fit_finder_size_selected', { profile: this.profile.key, selected_size: size });
        this.close();
        radio.focus({ preventScroll: true });
        return;
      }

      const selects = Array.from(productInfo.querySelectorAll('select'));
      const select = selects.find((element) => {
        const label = element.labels && element.labels[0] ? element.labels[0].textContent : '';
        return acceptedNames.some((name) => core.normalize(label).includes(name));
      });
      const option = select
        ? Array.from(select.options).find((entry) => core.normalize(entry.value) === core.normalize(size) && !entry.disabled)
        : null;
      if (select && option) {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        this.pushEvent('fit_finder_size_selected', { profile: this.profile.key, selected_size: size });
        this.close();
        select.focus({ preventScroll: true });
        return;
      }

      const notice = this.content.querySelector('.nt-fit__notice') || this.content.querySelector('.nt-fit__result-actions');
      if (notice) notice.insertAdjacentHTML('afterbegin', '<p class="nt-fit__inline-error" role="alert">Diese Größenkombination ist momentan nicht auswählbar.</p>');
    }

    bodyLabel() {
      return { slim: 'Schmal', athletic: 'Athletisch', strong: 'Kräftig' }[this.answers.body] || 'Athletisch';
    }

fitLabel() {
  return {
    tight: 'Eng anliegend',
    loose: 'Etwas lockerer'
  }[this.answers.fit] || 'Eng anliegend';
}

    pushEvent(event, details) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event, fit_finder: details });
      this.dispatchEvent(new CustomEvent(event, { bubbles: true, detail: details }));
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.boundKeydown);
      this.triggerWrap?.remove();
      document.body.classList.remove('nt-fit-open');
    }
  }

  customElements.define('never-tap-fit-finder', NeverTapFitFinder);

/*
 * Externe Links mit #fit-finder öffnen das Formular.
 */
if (!window.ntFitFinderLinkHandlerActive) {
  window.ntFitFinderLinkHandlerActive = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');

    if (!link) return;

    const targetUrl = new URL(link.href, window.location.href);

    if (targetUrl.hash !== '#fit-finder') return;

    const fitFinder = document.querySelector('never-tap-fit-finder');

    if (!fitFinder || typeof fitFinder.open !== 'function') {
      console.warn(
        'Der Fit Finder ist auf dieser Produktseite nicht verfügbar.'
      );
      return;
    }

    event.preventDefault();
    fitFinder.open();
  });
}


})();
